import {ManyResponse} from '@backend/responses/many.response';
import {RequestQueryBuilder} from '@nestjsx/crud-request';
import {DashboardCardSelections} from '../models';
import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Burly} from 'kb-burly';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TorchDashboardSelectionsService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  public getDashboardCards(dashboard: string,
                           user: string): Observable<ManyResponse<DashboardCardSelections>> {

    const filters = {
      $and: [
        {dashboard: {$eq: dashboard}},
        {enteredBy: {$eq: user}},
      ]
    };

    const qb = RequestQueryBuilder.create();

    qb.setLimit(1);

    if (!!filters) {
      qb.search(filters);
    }

    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/dashboard-cards')
      .appendRawQueryString(qb.query(false))
      .get;

    return this.httpClient.get<ManyResponse<DashboardCardSelections>>(endpointURL);
  }

  public addDashboardCards(cards: DashboardCardSelections) {
    cards.updatedAt = new Date().toISOString();

    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/dashboard-cards')
      .get;

    return this.httpClient.post<DashboardCardSelections>(endpointURL, cards).pipe(
      take(1)
    );
  }

  public updateDashboardCards(cards: DashboardCardSelections) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/dashboard-cards')
      .addSegment(`/${cards.id}`)
      .get;

    return this.httpClient.patch<DashboardCardSelections>(endpointURL, cards).pipe(
      take(1)
    );
  }
}
